export enum FiscalType {
  PessoaFisica = 1,
  PessoaJuridica = 2,
}
